(function ($) {
  'use strict';

  const ITEM_ID = '10107864';
  const SHOP_BID = '203706';
  const VARIANT_ID = '555a00050';

  const BASE_IMG = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/abtype/';
  const EXISTING_URL = 'https://item.rakuten.co.jp/arne/';

  const LIMITS = {
    haba: { min: 40, max: 180, label: '幅' },
    depth: { min: 15, max: 25, label: '奥行' },
    height: { min: 15, max: 40, label: '高さ' }
  };

  const MATERIAL_TEXT = {
    wood: 'リーズナブル木目：<br>[材質]プリント化粧合板',
    aino: 'パステルカラーaino：<br>[材質]強化紙化粧合板',
    mela: 'ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)'
  };

  const COLOR_BAND = {
    A: ['wood', 'aino'],
    B: ['nail', 'bk', 'bp'],
    C: ['mb', 'gs', 'ww']
  };

  const ROW_BASE_BY_DEPTH_AND_BAND = {
    shallow: { A: 0, B: 18, C: 36 }, // 奥行1～15
    middle: { A: 6, B: 24, C: 42 },  // 奥行16～20
    deep: { A: 12, B: 30, C: 48 }    // 奥行21～
  };

  const OPTION_HOLE_PRICE = 1500;

  const HOLE_PANEL_DATA = {
    panel_a: {
      letter: 'a',
      viewText: '板面：Aを上から見て',
      targetName: '天面',
      options: ['左奥', '中央奥', '右奥', '中央左', '中央', '中央右', '左手前(開口部側)', '中央手前(開口部側)', '右手前(開口部側)']
    },
    panel_b: {
      letter: 'b',
      viewText: '板面：Bを側面から見て',
      targetName: '左側板',
      options: ['左上', '左下', '中央', '右上(開口部側)', '右下(開口部側)']
    },
    panel_c: {
      letter: 'c',
      viewText: '板面：Cを正面から見て',
      targetName: '背板',
      options: ['左上', '中央上', '右上', '中央左', '中央', '中央右', '左下', '中央下', '右下']
    },
    panel_d: {
      letter: 'd',
      viewText: '板面：Dを側面から見て',
      targetName: '右側板',
      options: ['左上(開口部側)', '左下(開口部側)', '中央', '右上', '右下']
    },
    panel_e: {
      letter: 'e',
      viewText: '板面：Eを下から見て',
      targetName: '底面',
      options: ['左奥', '中央奥', '右奥', '中央左', '中央', '中央右', '左手前(開口部側)', '中央手前(開口部側)', '右手前(開口部側)']
    }
  };

  const HOLE_PANEL_ORDER = ['panel_a', 'panel_b', 'panel_c', 'panel_d', 'panel_e'];

  let priceTable = null;
  let existingList = null;
  let originalPanelSlides = null;
  let initialPanelFilterDone = false;

  function onlyDigits(v) {
    return String(v == null ? '' : v).replace(/[^\d]/g, '');
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    const isEmpty = cleaned === '';
    const val = isEmpty ? NaN : parseInt(cleaned, 10);
    return { el: el, val: val, isEmpty: isEmpty };
  }

  function ceil5(n) {
    return Math.ceil(n / 5) * 5;
  }

  function formatYen(n) {
    const s = String(n == null ? '' : n).replace(/[^\d]/g, '');
    if (!s) return '';
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
  }

  function formatApprox(n) {
    if (!Number.isFinite(n)) return '';
    const rounded = Math.round(n * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-9) return '約' + Math.round(rounded) + 'cm';
    return '約' + rounded.toFixed(1) + 'cm';
  }

  function normalizeColorToken(name) {
    const $checked = $('input[name="' + name + '"]:checked');
    const dataType = String($checked.data('type') || '').toLowerCase();
    const id = String($checked.attr('id') || '').toLowerCase();

    if (dataType === 'wood' || dataType === 'aino') return dataType;
    if (id.indexOf('mela_') === 0) return id.replace(/^mela_/, '').replace(/[12]$/, '');
    return String($checked.val() || '').toLowerCase();
  }

  function getBandByColor() {
    const token = normalizeColorToken('colortype1');
    if (COLOR_BAND.A.indexOf(token) !== -1) return 'A';
    if (COLOR_BAND.B.indexOf(token) !== -1) return 'B';
    if (COLOR_BAND.C.indexOf(token) !== -1) return 'C';
    return null;
  }

  function getSelectedColorName(name) {
    return $('input[name="' + name + '"]:checked').val() || '';
  }

  function getSelectedColorId(name) {
    return $('input[name="' + name + '"]:checked').attr('id') || '';
  }

  function getSelectedMaterialType(name) {
    return String($('input[name="' + name + '"]:checked').data('type') || '').toLowerCase();
  }

  function stripColorSuffix(id) {
    return String(id || '').replace(/[12]$/, '');
  }

  function getImagePattern() {
    const w = readInt('haba').val;
    const h = readInt('height').val;
    return (w === 40 && h === 40) ? '402140' : '1202130';
  }

  function $sizeMsg() {
    return $('.form_size').closest('.form').find('> .msg').first();
  }

  function $orderMsg() {
    return $('.order-summary > .msg');
  }

  function setCheckoutUIEnabled(on) {
    const price = document.querySelector('.check_price');
    const cart = document.querySelector('.cart--btn');
    if (price) price.setAttribute('style', on ? '' : 'visibility: hidden');
    if (cart) {
      if (on) cart.removeAttribute('disabled');
      else cart.setAttribute('disabled', '');
    }
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $('.check_area li span').text('');
    $('.check_price').empty();
    setCheckoutUIEnabled(false);
    $('#units').val('');
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-ab_price.csv?v=1783301615', dataType: 'text' }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ''), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-ab_existing.csv?v=1783301615', dataType: 'text' }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function setBubbleBySelectedColor() {
    $('input[name="colortype1"], input[name="colortype2"]').each(function () {
      const $form = $(this).closest('.form');
      const checked = $form.find('input[type="radio"]:checked').first();
      const type = String(checked.data('type') || '').toLowerCase();
      $form.find('.material_bubble').html(MATERIAL_TEXT[type] || '選択してください');
    });
  }

  function resizeFormSizeImages() {
    const $wrap = $('.form_size--img');
    if (!$wrap.length) return;
    const width = $wrap.width();
    let maxH = 0;

    $wrap.find('img').each(function () {
      if (width) $(this).css('width', width + 'px');
      const h = $(this).height();
      if (h > maxH) maxH = h;
    });

    if (maxH > 0) $wrap.height(maxH);
  }

  function bindResizeAfterLoad() {
    $('.form_size--img img').off('load.wbAbResize').on('load.wbAbResize', function () {
      resizeFormSizeImages();
    });
  }

  function updatePreviewImages() {
    const pattern = getImagePattern();
    const bodyId = stripColorSuffix(getSelectedColorId('colortype1')) || 'wood_br';
    const panelId = stripColorSuffix(getSelectedColorId('colortype2')) || 'wood_br';
    const area1 = document.querySelector('.form_size--img img[name="area1"]');
    const area2 = document.querySelector('.form_size--img img[name="area2"]');
    const area3 = document.querySelector('.form_size--img img[name="area3"]');

    if (area1) area1.src = BASE_IMG + pattern + '/arrow.png';
    if (area2) area2.src = BASE_IMG + pattern + '/' + bodyId + '.png';
    if (area3) area3.src = BASE_IMG + pattern + '/' + panelId + '-bpanel.png';

    resizeFormSizeImages();
  }

  function calcInnerWidth(width, materialType) {
    if (!Number.isFinite(width)) return NaN;
    return materialType === 'mela' ? width - 3.4 : width - 3.6;
  }

  function calcInnerDepth(depth, materialType) {
    if (!Number.isFinite(depth)) return NaN;
    return materialType === 'mela' ? depth - 2.5 : depth - 2.6;
  }

  function calcInnerHeight(height, materialType) {
    if (!Number.isFinite(height)) return NaN;
    return materialType === 'mela' ? height - 3.7 : height - 3.9;
  }

  function updateInnerDisplayOne(key) {
    const materialType = getSelectedMaterialType('colortype1') || 'wood';
    const rec = readInt(key);
    let value = NaN;
    let outId = '';
    let lim = null;

    if (key === 'haba') {
      value = calcInnerWidth(rec.val, materialType);
      outId = 'haba_id';
      lim = LIMITS.haba;
    } else if (key === 'depth') {
      value = calcInnerDepth(rec.val, materialType);
      outId = 'depth_id';
      lim = LIMITS.depth;
    } else if (key === 'height') {
      value = calcInnerHeight(rec.val, materialType);
      outId = 'height_id';
      lim = LIMITS.height;
    }

    if (!outId) return;

    if (rec.isEmpty || !Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      $('#' + outId).val('');
      return;
    }

    $('#' + outId).val(formatApprox(value));
  }

  function updateInnerDisplays() {
    updateInnerDisplayOne('haba');
    updateInnerDisplayOne('depth');
    updateInnerDisplayOne('height');
  }

  function removeSizeError(key) {
    $sizeMsg().find('.note-size-error[data-error-key="' + key + '"]').remove();
  }

  function setSizeError(key, text) {
    removeSizeError(key);
    if (!text) return;
    $sizeMsg().append($('<p class="note-size-error">').attr('data-error-key', key).text(text));
  }

  function validateSizeFieldForBlur(key) {
    const lim = LIMITS[key];
    if (!lim) return;
    const rec = readInt(key);
    if (rec.isEmpty) {
      removeSizeError(key);
      return;
    }
    if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      setSizeError(key, lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + (Number.isFinite(rec.val) ? rec.val : '') + 'cm）');
      return;
    }
    removeSizeError(key);
  }

  function buildJumpSizeErrors() {
    const errors = [];
    ['haba', 'depth', 'height'].forEach(function (key) {
      const lim = LIMITS[key];
      const rec = readInt(key);
      if (rec.isEmpty) {
        errors.push(lim.label + 'を入力してください');
      } else if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
        errors.push(lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + rec.val + 'cm）');
      }
    });
    return errors;
  }

function getExistingMaterialKey(name) {
  const type = getSelectedMaterialType(name);

  if (type === 'mela') {
    return stripColorSuffix(getSelectedColorId(name)).toLowerCase();
  }

  return type;
}

  function findExistingCode(data) {
    if (!Array.isArray(existingList)) return null;
    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i] || [];
      const code = String(row[0] || '').trim();
      const w = parseInt(String(row[1] || '').replace(/[^\d]/g, ''), 10);
      const d = parseInt(String(row[2] || '').replace(/[^\d]/g, ''), 10);
      const h = parseInt(String(row[3] || '').replace(/[^\d]/g, ''), 10);
      const body = String(row[4] || '').trim().toLowerCase();
      const panel = String(row[5] || '').trim().toLowerCase();

      if (!code) continue;
      if (
        w === data.haba &&
        d === data.depth &&
        h === data.height &&
        body === String(data.bodyType).toLowerCase() &&
        panel === String(data.panelType).toLowerCase()
      ) {
        return code;
      }
    }
    return null;
  }

  function getShopMark(haba, depth, height) {
    return (haba + depth + height + 10 <= 201) ? '★' : '☆';
  }

  function getSelectedHolePanelKey() {
    return $('input[name="op_panel"]:checked').attr('id') || '';
  }

  function getSelectedHolePosition() {
    const val = $('select[name="op_hole--position"]').val() || '';
    return val === '穴位置を選択' ? '' : val;
  }

  function getHoleOptionText() {
    if (!$('#op_hole').prop('checked')) return '';
    const panelKey = getSelectedHolePanelKey();
    const pos = getSelectedHolePosition();
    const data = HOLE_PANEL_DATA[panelKey];
    if (!data || !pos) return '';
    return '配線穴(' + data.targetName + 'の' + pos + ')';
  }

function syncHoleArea() {
  const on = $('#op_hole').prop('checked');

  $('.op_hole-area').toggle(on);

  const panelSelected = $('input[name="op_panel"]:checked').length > 0;
  $('.op_hole--position').toggle(on && panelSelected);

  if (!on) {
    $('input[name="op_panel"]').prop('checked', false);

    $('select[name="op_hole--position"]')
      .empty()
      .append(
        $('<option>')
          .text('穴位置を選択')
          .val('穴位置を選択')
      );
  }
}

  function renderHolePanel(panelKey) {
    const data = HOLE_PANEL_DATA[panelKey];
    if (!data) return;

    $('.op_hole--position p span').html(
      data.viewText +
      '<img src="' + BASE_IMG + 'panel_choice-' + data.letter + '.png">'
    );

    const $select = $('select[name="op_hole--position"]');
    $select.empty();
    $select.append($('<option>').text('穴位置を選択').val('穴位置を選択'));

    data.options.forEach(function (label) {
      $select.append($('<option>').text('穴位置：' + label).val(label));
    });

    $('.op_hole--position').show();
  }

  window.choicePanel = function choicePanel(index) {
    renderHolePanel(HOLE_PANEL_ORDER[index]);
  };

  function setChoiceValues(data) {
    const choice1 = '幅：' + data.haba + 'cm/';
    const choice2 = '奥行：' + data.depth + 'cm/';
    const choice3 = '高さ：' + data.height + 'cm/';
    const choice4 = '本体カラー：' + data.bodyColor + '/';
    const choice5 = '背板カラー：' + data.panelColor + '/';
    const choice6 = 'オプション：' + (data.optionText || 'なし') + '/';
    const choice7 = '店舗用記号：' + data.shopMark + '/';
    const choice8 = '見積もり金額：' + data.price;

    $('#choice1').val(choice1);
    $('#choice2').val(choice2);
    $('#choice3').val(choice3);
    $('#choice4').val(choice4);
    $('#choice5').val(choice5);
    $('#choice6').val(choice6);
    $('#choice7').val(choice7);
    $('#choice8').val(choice8);
    $('#units').val(String(Math.round(data.price / 100)));
  }

  function buildEncodedChoice() {
    const lines = [
      $('#choice1').val(),
      $('#choice2').val(),
      $('#choice3').val(),
      $('#choice4').val(),
      $('#choice5').val(),
      $('#choice6').val(),
      $('#choice7').val(),
      $('#choice8').val()
    ].filter(function (v) {
      return String(v || '').length > 0;
    });

    const choice = lines.join('\r\n');
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: 'EUCJP', from: 'UNICODE' });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const units = $('#units').val();
    if (!units || !$('#choice1').val() || !$('#choice7').val()) return false;

    const encodedChoice = buildEncodedChoice();
    const existingForm = document.querySelector('form[name="cart_form_ori"]');
    if (existingForm) existingForm.remove();

    const form = document.createElement('form');
    form.method = 'post';
    form.name = 'cart_form_ori';
    form.action = 'https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set';
    form.acceptCharset = 'EUC-JP';
    form.target = '_blank';

    [
      { name: 'shop_bid', value: SHOP_BID },
      { name: 'item_id', value: ITEM_ID },
      { name: 'variant_id', value: VARIANT_ID },
      { name: 'units', value: units },
      { name: 'choice', value: encodedChoice }
    ].forEach(function (d) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return false;
  }

  function getColorRoot() {
    const roots = $('.splide[aria-label="カラーを選択"], .splide[aria-label="材質とカラーの選択"], #splide03, .material_area').toArray();
    for (let i = 0; i < roots.length; i++) {
      if ($(roots[i]).find('input[name="colortype2"]').length) return roots[i];
    }
    return null;
  }

  function getSplideInstance(root) {
    if (!root || !window.__splideMap) return null;
    if (typeof window.__splideMap.get === 'function') {
      const direct = window.__splideMap.get(root);
      if (direct) return direct;
    }
    if (typeof window.__splideMap.entries === 'function') {
      const entries = window.__splideMap.entries();
      let next = entries.next();
      while (!next.done) {
        const key = next.value[0];
        const val = next.value[1];
        if (key === root || (key && key === $(root).get(0)) || (key && root && key.id && key.id === root.id)) return val;
        next = entries.next();
      }
    }
    return null;
  }

  function cacheOriginalPanelSlides(root) {
    if (originalPanelSlides || !root) return;
    originalPanelSlides = [];
    $(root).find('.splide__slide').not('.splide__slide--clone').each(function () {
      originalPanelSlides.push(this.outerHTML);
    });
  }

  function rebuildPanelSlides(targetTypes) {
    const root = getColorRoot();
    if (!root) return;
    cacheOriginalPanelSlides(root);
    if (!originalPanelSlides || !originalPanelSlides.length) return;

    const selected = $('input[name="colortype2"]:checked').first();
    const keepId = selected.attr('id') || '';
    const keepValue = selected.val() || '';
    const htmls = originalPanelSlides.filter(function (html) {
      const $tmp = $(html);
      const type = String($tmp.find('input[name="colortype2"]').data('type') || '').toLowerCase();
      return targetTypes.indexOf(type) !== -1;
    });

    const splide = getSplideInstance(root);
    let rebuilt = false;

    if (splide && typeof splide.remove === 'function' && typeof splide.add === 'function') {
      try {
        const count = $(root).find('.splide__slide').not('.splide__slide--clone').length;
        const indexes = [];
        for (let i = 0; i < count; i++) indexes.push(i);
        indexes.reverse().forEach(function (idx) { splide.remove(idx); });
        htmls.forEach(function (html) { splide.add(html); });
        if (typeof splide.refresh === 'function') splide.refresh();
        if (typeof splide.go === 'function') splide.go(0);
        rebuilt = true;
      } catch (err) {
        rebuilt = false;
      }
    }

    if (!rebuilt) {
      const list = $(root).find('.splide__list').get(0);
      if (list) {
        list.innerHTML = htmls.join('');
        if (splide && typeof splide.refresh === 'function') {
          try { splide.refresh(); } catch (err2) {}
        }
        if (splide && typeof splide.go === 'function') {
          try { splide.go(0); } catch (err3) {}
        }
      }
    }

    const $inputs = $(root).find('input[name="colortype2"]');
    let $next = $();
    if (keepId) $next = $inputs.filter('#' + keepId);
    if (!$next.length && keepValue) {
      $next = $inputs.filter(function () { return $(this).val() === keepValue; });
    }
    if (!$next.length) $next = $inputs.first();
    if ($next.length) $next.prop('checked', true).trigger('change');
  }

  function applyPanelFilterByBodyColor() {
    const type = getSelectedMaterialType('colortype1');
    if (type === 'mela') rebuildPanelSlides(['mela']);
    else if (type === 'wood' || type === 'aino') rebuildPanelSlides(['wood', 'aino']);
  }

function priceRowFor(height5, band, depth) {
  let depthKey = '';

  if (depth <= 15) {
    depthKey = 'shallow';
  } else if (depth <= 20) {
    depthKey = 'middle';
  } else {
    depthKey = 'deep';
  }

  const base = ROW_BASE_BY_DEPTH_AND_BAND[depthKey][band];
  if (base == null) return NaN;

  return base + Math.round((height5 - 15) / 5);
}

  function priceColFor(width5) {
    return Math.round((width5 - 40) / 5);
  }

  window.jump = function jump() {
    const $msg = $orderMsg();
    $msg.empty();

    const sizeErrors = buildJumpSizeErrors();
    const bodyColor = getSelectedColorName('colortype1');
    const panelColor = getSelectedColorName('colortype2');
    const materialType = getSelectedMaterialType('colortype1');
    const band = getBandByColor();
    const holeOn = $('#op_hole').prop('checked');
    const holePanelKey = getSelectedHolePanelKey();
    const holePosition = getSelectedHolePosition();
    const optionText = getHoleOptionText();

    if (sizeErrors.length) {
      sizeErrors.forEach(function (t) {
        $msg.append($('<p class="note-submit-error">').text(t));
      });
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (!bodyColor || !panelColor || !materialType || !band) {
      $msg.append($('<p class="note-submit-error">').text('カラーを選択してください'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (holeOn && (!holePanelKey || !holePosition)) {
      $msg.append($('<p class="note-submit-error">').text('配線穴の板面と穴位置を選択してください'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    if (!Array.isArray(priceTable) || !priceTable.length) {
      $msg.append($('<p class="note-submit-error">').text('価格表の読み込みに失敗しました'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    const haba = readInt('haba').val;
    const depth = readInt('depth').val;
    const height = readInt('height').val;
    const width5 = ceil5(haba);
    const height5 = ceil5(height);
    const row = priceRowFor(height5, band, depth);
    const col = priceColFor(width5);
    const basePrice = priceTable[row] && priceTable[row][col];

    if (!Number.isFinite(basePrice)) {
      $msg.append($('<p class="note-submit-error">').text('価格が見つかりませんでした'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty();
      $('#units').val('');
      return false;
    }

    const existingCode = findExistingCode({
      haba: haba,
      depth: depth,
      height: height,
      bodyType: getExistingMaterialKey('colortype1'),
      panelType: getExistingMaterialKey('colortype2')
    });

    if (!holeOn && existingCode) {
      $msg.append(
        '<p class="existing-link">' +
          '<a href="' + EXISTING_URL + existingCode + '" target="_blank">' +
            '→既製品ページがございます。こちらのページよりお買い求めください。' +
          '</a>' +
        '</p>'
      );
      $('.check_price').empty();
      setCheckoutUIEnabled(false);
      $('#units').val('');
      return false;
    }

    let price = basePrice;
    if (materialType === 'aino') price += 1000;
    if (holeOn) price += OPTION_HOLE_PRICE;

    const shopMark = getShopMark(haba, depth, height);
    const spans = document.querySelectorAll('.check_area ul li span');
    if (spans.length >= 6) {
      spans[0].textContent = haba;
      spans[1].textContent = depth;
      spans[2].textContent = height;
      spans[3].textContent = bodyColor;
      spans[4].textContent = panelColor;
      spans[5].textContent = optionText || 'なし';
    }

    setChoiceValues({
      haba: haba,
      depth: depth,
      height: height,
      bodyColor: bodyColor,
      panelColor: panelColor,
      optionText: optionText,
      shopMark: shopMark,
      price: price
    });

    $('.check_price').text(formatYen(price)).attr('style', '');
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  window.checkBtn = function () { return true; };

  $(function () {
    loadPriceOnce();
    loadExistingOnce();
    bindResizeAfterLoad();

    setBubbleBySelectedColor();
    updateInnerDisplays();
    updatePreviewImages();
    resizeFormSizeImages();
    resetOrderSummary();

    $('.op_hole-area').hide();
    syncHoleArea();
    $('.op_hole--position').hide();

    $(window).on('resize', resizeFormSizeImages);
    $(window).on('pageshow', function () {
      setBubbleBySelectedColor();
      updateInnerDisplays();
      updatePreviewImages();
      resizeFormSizeImages();
    });

    $(document).on('change', 'input[name="colortype1"]', function () {
      if (!this.checked) return;
      setBubbleBySelectedColor();
      applyPanelFilterByBodyColor();
      updateInnerDisplays();
      updatePreviewImages();
    });

    $(document).on('change', 'input[name="colortype2"]', function () {
      if (!this.checked) return;
      setBubbleBySelectedColor();
      updatePreviewImages();
    });

    $(document).on('change', '#op_hole', function () {
      syncHoleArea();
    });

    $(document).on('change', 'input[name="op_panel"]', function () {
      if (this.checked) renderHolePanel(this.id);
    });

    $(document).on('input', '#haba, #depth, #height', function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
      updateInnerDisplayOne(this.id);
      updatePreviewImages();
    });

    $(document).on('blur', '#haba, #depth, #height', function () {
      validateSizeFieldForBlur(this.id);
    });

    $('form[name="frm_detail"]').on('change input', 'input, select, textarea', function () {
      const $t = $(this);
      if ($t.is('#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7, #choice8')) return;
      resetOrderSummary();
    });

    $(document).on('click', '#modal-cart', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('click', '.btn-cart, .cartadd', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm_detail"]', function (e) {
      e.preventDefault();
      submitToRakutenCart(e);
      return false;
    });

    $(document).on('submit', 'form[name="frm"]', function (e) {
      submitToRakutenCart(e);
      return false;
    });

    window.setTimeout(function () {
      if (initialPanelFilterDone) return;
      initialPanelFilterDone = true;
      applyPanelFilterByBodyColor();
    }, 0);
  });

})(jQuery);
